import { render, staticRenderFns } from "./SettingsPayments.vue?vue&type=template&id=456a8f9c&"
import script from "./SettingsPayments.vue?vue&type=script&lang=js&"
export * from "./SettingsPayments.vue?vue&type=script&lang=js&"
import style0 from "./SettingsPayments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports